<template>
<div class="main-body">
  <b-alert
    dismissible
    :show="showDismissibleAlert"
    :variant="alertVariant"
    @dismissed="showDismissibleAlert=false">{{ alertMessage }}</b-alert>
    <form>
      <div class="card">
          <div class="card-body">
              <div class="row">
                  <div class="col-sm-5">
                      <h4 class="card-title mb-0">
                        Management <small class="text-muted">FAQ</small>
                      </h4>
                  </div><!--col-->
              </div><!--row-->

              <div class="row mt-4">
                  <div class="col">
                      <div class="form-group row">
                        <label for="courier_id" class="col-sm-2 col-form-label">{{ $t('marketplace.marketplace_name') }}</label>
                        <div class="col-sm-4" v-bind:class="{'form-group--error': $v.marketplaceFaq.marketplace_id.$error }">
                          <select class="form-control" v-model.trim="marketplaceFaq.marketplace_id">
                            <option :value="null" key="Please select an platform">Please select an platform</option>
                            <option value="99" key="all">All Platform</option>
                            <option v-for="(marketplace, index) in marketplaces" :value="marketplace.id" :key="index">{{ marketplace.name }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="title" class="col-sm-2 col-form-label form__label">{{ $t('marketplace.faq.title') }}</label>
                        <div class="col-sm-6" v-bind:class="{'form-group--error': $v.marketplaceFaq.title.$error }">
                          <input v-model.trim="marketplaceFaq.title" @input="$v.marketplaceFaq.title.$touch()" type="text" name="title" class="form-control form__label">
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="content" class="col-sm-2 col-form-label">{{ $t('marketplace.faq.content') }}</label>
                        <div class="col-sm-6" v-bind:class="{'form-group--error': $v.marketplaceFaq.content.$error }">
                          <textarea rows="4" v-model.trim="marketplaceFaq.content" @input="$v.marketplaceFaq.content.$touch()" type="text" name="content" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="status" class="col-sm-2 col-form-label">{{ $t('marketplace.faq.status') }}</label>
                        <div class="col-sm-8">
                          <CSwitch class="mx-1"  :checked.sync="marketplaceFaq.status" color="primary" variant="outline" shape="pill"/>
                        </div>
                      </div>
                  </div><!--col-->
              </div><!--row-->

              <div slot="footer">
                <div class="row">
                    <div class="col-7">
                        <div class="float-left"></div>
                    </div><!--col-->
                    <div class="col-5">
                        <div class="float-right">
                            <b-button type="submit" size="sm" variant="primary" @click.stop.prevent="handleSubmit"><i class="fa fa-dot-circle-o"></i> Submit</b-button>
                        </div>
                    </div><!--col-->
                </div><!--row-->
              </div>
          </div><!--card-body-->
      </div><!--card-->
    </form>
   <loading-panel v-if="showLoadingPanel"></loading-panel>
  </div>
</template>
<script>
import { required, minLength } from 'vuelidate/lib/validators'
import loadingPanel from '@/components/LoadingPanel'

export default {
  name: 'StoreCreate',
  components: {
    loadingPanel
  },
  mounted () {
    this.axios.get('/marketplace/platform').then(response => {
      this.marketplaces = response.data
    }).catch(error => {
      console.log(error)
    })
  },
  data () {
    return {
      marketplaces: [],
      marketplaceFaq: {
        marketplace_id: null,
        title: '',
        content: '',
        status: true
      },
      showLoadingPanel: false,
      showDismissibleAlert: false,
      alertVariant: '',
      alertMessage: '',
      message: ''
    }
  },
  methods: {
    handleSubmit () {
      this.$v.marketplaceFaq.$touch()
        if (!this.$v.marketplaceFaq.$error) {
        // create store
        this.showLoadingPanel = true
        this.axios.post('/marketplace/faq', this.marketplaceFaq).then(() => {
          this.showLoadingPanel = false
          this.$router.push('/marketplace/faq')
        }).catch(error => {
          this.showLoadingPanel = false
          this.showAlert('danger', error.data.message)
        })
      }
    },
    showAlert (alertVariant, message) {
      this.showDismissibleAlert = true
      this.alertVariant = alertVariant
      this.alertMessage = message
    }
  },
  validations: {
    marketplaceFaq: {
      marketplace_id: {
        required,
        minLength: minLength(1)
      },
      title: {
        required
      },
      content: {
        required
      },
    }
  }
}
</script>
